// src/components/ScrollToTop.tsx

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  // Extrai o "pathname" (ex: "/sobre", "/projetos") da localização atual
  const { pathname } = useLocation();

  // O useEffect é executado toda vez que o "pathname" muda
  useEffect(() => {
    // A mágica acontece aqui: isso manda a janela para o topo (posição 0, 0)
    window.scrollTo(0, 0);
  }, [pathname]); // O array de dependências garante que o efeito só rode ao mudar de URL

  // Este componente não renderiza nada visualmente
  return null;
};

export default ScrollToTop;